import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {articleAnalysis_template} from "../components/templates/articleAnalysis_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class articleAnalysis extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected articleAnalysis_template: articleAnalysis_template;

    protected getModuleName(){

        return "articleAnalysis";
    }

    buildContent() : Array<Element>{

        // If someone is still using an old bookmark for the organic article analysis, we redirect to the new article analysis path.
        if (window.location.pathname == '/organic/article_analysis') {

            let queryString = window.location.search || "";
            page.redirect('/article_analysis' + queryString);
        }

        this.articleAnalysis_template = new articleAnalysis_template( "articleAnalysis", this.viewModel, this );
        this.template = this.articleAnalysis_template;

        return [this.articleAnalysis_template.build()];
    }

    public fillPage() : void{

        this.articleAnalysis_template.buildDatePickerCalendar();

        // First get the presets
        this.getSearchPresetsListData();
    }

    public getListFormData(): void{

        let usrReq_url: string = '/api/articleAnalysis/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.articleAnalysis_template.validationsList.clearMessages();
                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getListData();
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.loadingOut(obj.articleAnalysis_template.builtTemplate);
            }
        };
    }

    protected updateFilters(responseParsed: any){

        this.articleAnalysis_template.setViewModesItems();
        this.articleAnalysis_template.setBrandFilterItems(responseParsed.departments);
        this.articleAnalysis_template.setBrandSegments(responseParsed.brandSegments);
        this.articleAnalysis_template.setPostInitiativesFilterItems(responseParsed.postInitiatives);
        this.articleAnalysis_template.setPostPaymentCategorySystemFilterItems(responseParsed.postPaymentCategorySystems);
        this.articleAnalysis_template.setPostIntentsFilterItems(responseParsed.postIntents);
        this.articleAnalysis_template.setPostContentTypesFilterItems(responseParsed.groupedContentTypes);
        this.articleAnalysis_template.setNetworkCategoriesFilterItems(responseParsed.groupedNetworkCategories);
        this.articleAnalysis_template.setGeosFilterItems(responseParsed.geos);
        this.articleAnalysis_template.setPublishedDatesDisablerItems();
        this.articleAnalysis_template.setPublishStatusItems();
        this.articleAnalysis_template.setArticleTypeItems();
        this.articleAnalysis_template.setDeviceFilterItems();
        this.articleAnalysis_template.setDataRangesItems();
        this.articleAnalysis_template.setOperatingSystemsFilterItems();
        this.articleAnalysis_template.setPostContentTypesGroupFilterItems();
        this.articleAnalysis_template.setBrandSafetyFilterItems();
    }

    public getListData(): void{

        this.loadingIn(this.articleAnalysis_template.builtTemplate.children.namedItem("list-results"));
        this.articleAnalysis_template.hideExportButton();

        let subViewModel = this.articleAnalysis_template.getViewModelForRequest();
        let baseApiUrl = '/api/articleAnalysis/get';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.articleAnalysis_template.validationsList.clearMessages();
                obj.articleAnalysis_template.resetSelectedRows();
                obj.setPermissions(responseParsed.data.isCostDataAccessible, responseParsed.data.isFinancialDataAccessible);
                obj.updateList(responseParsed.data.paginatedData, responseParsed.totals);
                obj.updatePagination(responseParsed.totalCount);
                obj.setResultInfo(responseParsed.totalCount, responseParsed.totalPage);
            });

            if(req.request.readyState == 4 && req.request.status !== 0){

                // LOADING : ends
                obj.loadingOut(obj.articleAnalysis_template.builtTemplate.children.namedItem("list-results"));
            }
        };
    }

    protected setPermissions(isCostDataAccessible, isFinancialDataAccessible) {

        this.articleAnalysis_template.setPermissions(isCostDataAccessible, isFinancialDataAccessible);
    }

    protected updateList(responseParsedData: any, responseParsedTotals: any) {

        if(this.articleAnalysis_template.getTemplateViewModel().viewModeSelected()=="article"){

            this.articleAnalysis_template.setArticleData(responseParsedData);
        }else{

            this.articleAnalysis_template.setArticleVideoData(responseParsedData);
        }

    }

    protected updatePagination(totalCount) {

        this.articleAnalysis_template.updatePagination(totalCount);
    }

    protected setResultInfo(totalCount, totalPage){

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.articleAnalysis_template.setResultInfo(totalCount, totalPage, execTime);
    }


    public getListDataForCSV(): void{

        this.loadingIn(this.articleAnalysis_template.builtTemplate.children.namedItem("list-results"));

        if( this.XHRHdl ){

            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = this.articleAnalysis_template.getViewModelForRequest();
        subViewModel["export"] = true;

        let usrReq_url: string = '/api/articleAnalysis/get';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onCSVDataRequestReturn;
        this.XHRHdl.execute();
    }

    protected onCSVDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.articleAnalysis_template.validationsList.clearMessages();
                obj.articleAnalysis_template.setCsvExportData(responseParsed);
                obj.articleAnalysis_template.exportCsvData();
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.loadingOut(obj.articleAnalysis_template.builtTemplate.children.namedItem("list-results"));
            }
        };
    }

    protected getAutoCompleteSuggestions(id, keyword) {

        let subViewModel = {
            filters      : {
                keyword : keyword,
            }
        };

        let usrReq_url: string = '';
        let usrReq_callback;
        switch (id){

            case 'primaryTagFilter':{

                usrReq_url = '/api/emakiBasicTagSuggestions/';
                usrReq_callback = this.onGetAutoCompletePrimaryTagsSuggestionsReturn;
                break;
            }
            case 'tagsFilter':{

                usrReq_url = '/api/emakiBasicTagSuggestions/';
                usrReq_callback = this.onGetAutoCompleteTagsSuggestionsReturn;
                break;
            }

            case 'tagTypesFilter':{

                usrReq_url = '/api/emakiBasicTagTypeSuggestions/';
                usrReq_callback = this.onGetAutoCompleteTagTypesSuggestionsReturn;
                break;
            }

            case 'primaryCategoriesFilter':{

                usrReq_url = '/api/emakiCategorySuggestions/';
                usrReq_callback = this.onGetAutoCompleteCategoriesSuggestionsReturn;
                break;
            }
        }

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = usrReq_callback;
        this.XHRHdl.execute();
    }

    protected onGetAutoCompletePrimaryTagsSuggestionsReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data){

                    obj.articleAnalysis_template.setPrimaryTagFilterItems(responseParsed.data);
                }
            });
        };
    }

    protected onGetAutoCompleteTagsSuggestionsReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data){

                    obj.articleAnalysis_template.setTagsFilterItems(responseParsed.data);
                }
            });
        };
    }

    protected onGetAutoCompleteTagTypesSuggestionsReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data){

                    obj.articleAnalysis_template.setTagTypesFilterItems(responseParsed.data);
                }
            });
        };
    }

    protected onGetAutoCompleteCategoriesSuggestionsReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data){

                    obj.articleAnalysis_template.setPrimaryCategoriesFilterItems(responseParsed.data);
                }
            });
        };
    }

    protected getMultipleAutoCompleteSuggestions(id, keyword) {

        let subViewModel = {
            filters      : {
                keyword : keyword,
            }
        };

        let usrReq_url = '/api/emakiUsers/get/';
        let usrReq_callback;
        switch (id){

            case 'srEditorsFilter':{

                usrReq_callback = this.onGetMultipleAutoCompleteSrEditorsSuggestionsReturn;
                break;
            }

            case 'jrEditorsFilter':{

                usrReq_callback = this.onGetMultipleAutoCompleteJrEditorsSuggestionsReturn;
                break;
            }

            case 'authorsFilter':{

                usrReq_callback = this.onGetMultipleAutoCompleteAuthorSuggestionsReturn;
                break;
            }

            case 'ideatorsFilter':{

                usrReq_callback = this.onGetMultipleAutoCompleteIdeatorSuggestionsReturn;
                break;
            }
        }

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = usrReq_callback;
        this.XHRHdl.execute();
    }

    protected onGetMultipleAutoCompleteSrEditorsSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if(responseParsed.data){

                    obj.articleAnalysis_template.setSrEditorsFilterItems(responseParsed.data);
                }
            });
        };

    }

    protected onGetMultipleAutoCompleteJrEditorsSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data){

                    obj.articleAnalysis_template.setJrEditorsFilterItems(responseParsed.data);
                }
            });
        };
    }

    protected onGetMultipleAutoCompleteAuthorSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if(responseParsed.data){

                    obj.articleAnalysis_template.setAuthorsFilterItems(responseParsed.data);
                }
            });
        };
    }

    protected onGetMultipleAutoCompleteIdeatorSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if(responseParsed.data){

                    obj.articleAnalysis_template.setIdeatorsFilterItems(responseParsed.data);
                }
            });
        };
    }

    protected filterMultipleSelectorOnChange(){

        this.resetPageNumber();
        this.getListData();
    }

    protected filterDateOnChange(){

        this.resetPageNumber();
        this.getListData();
    }

    protected filterSearchOnChange(){

        this.resetPageNumber();
        this.getListData();
    }

    protected filterSimpleOnChange(){

        this.resetPageNumber();
        this.getListData();
    }

    public filterDropdownOnChange(){

        this.togglePublishDatePicker();
        this.resetPageNumber();
        this.getListData();
    }

    private togglePublishDatePicker(): void {

        this.articleAnalysis_template.setPublishedDatePickerEnabled(
            this.articleAnalysis_template.isPublishDatesPickerEnabled()
        );
    }

    protected filterSearchCancel(){

        if( this.XHRHdl ){

            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){

            this.XHRHdl.cancelAndReset();
        }
    }

    protected paginationOnPageClick(){

        this.getListData();
    }

    public listReorder(){

        this.getListData();
    }

    private resetPageNumber(){

        // go back to page 1 in the pagination
        this.articleAnalysis_template.resetPageNumber();
    }

    private formatDate(date) {

        let weekday = new Array(7);
        weekday[0] = "Sunday";
        weekday[1] = "Monday";
        weekday[2] = "Tuesday";
        weekday[3] = "Wednesday";
        weekday[4] = "Thursday";
        weekday[5] = "Friday";
        weekday[6] = "Saturday";

        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear(),
            dayOfWeek = weekday[d.getDay()];


        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return dayOfWeek + ', ' + [year, month, day].join('-');
    }
}



// WEBPACK FOOTER //
// ./js/modules/articleAnalysis.ts